import { jsx as a, jsxs as s } from "react/jsx-runtime";
import { I as y } from "./ic_add-Vjwi0Osr.mjs";
import "react";
import { c as o } from "./tw-cn-mXgPecoF.mjs";
import { e as f } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as p } from "./index-BpNK5r1N.mjs";
const h = ["medium", "large", "xlarge"], x = p(["flex items-center justify-center rounded-full  tabular-nums"], {
  variants: {
    hasIcon: {
      true: "",
      false: ""
    },
    type: {
      filled_basic: "bg-fill-neutral-weak text-text-neutral-main",
      filled_blackop: "bg-opacity-black-50 text-static-white"
    },
    size: {
      xlarge: "min-h-32 typography-body-14-regular",
      large: "min-h-26 typography-body-12-regular",
      medium: "min-h-20 py-2 typography-label-10-regular"
    },
    pcSize: {
      xlarge: "pc:min-h-32 pc:typography-body-14-regular",
      large: "pc:min-h-26 pc:typography-body-12-regular",
      medium: "pc:min-h-20 py-2 pc:typography-label-10-regular"
    }
  },
  compoundVariants: [
    ...h.flatMap((e) => [
      {
        hasIcon: !0,
        size: e,
        className: {
          medium: "px-4 min-w-58",
          large: "pl-6 pr-8 min-w-70",
          xlarge: "pl-6 pr-8 min-w-82"
        }[e]
      },
      {
        hasIcon: !1,
        size: e,
        className: {
          medium: "pl-6 pr-10 min-w-52",
          large: "pl-8 pr-12 min-w-60",
          xlarge: "pl-12 pr-16 min-w-76"
        }[e]
      },
      {
        hasIcon: !0,
        pcSize: e,
        className: {
          medium: "pc:px-4 pc:min-w-58",
          large: "pc:pl-6 pc:pr-8 pc:min-w-70",
          xlarge: "pc:pl-6 pc:pr-8 pc:min-w-82"
        }[e]
      },
      {
        hasIcon: !1,
        pcSize: e,
        className: {
          medium: "pc:pl-6 pc:pr-10 pc:min-w-52",
          large: "pc:pl-8 pc:pr-12 pc:min-w-60",
          xlarge: "pc:pl-12 pc:pr-16 pc:min-w-76"
        }[e]
      }
    ])
  ]
}), I = p("", {
  variants: {
    size: {
      xlarge: "size-14",
      large: "size-14",
      medium: "size-12"
    },
    pcSize: {
      xlarge: "pc:size-14",
      large: "pc:size-14",
      medium: "pc:size-12"
    }
  }
}), v = p("font-bold", {
  variants: {
    hasIcon: {
      true: "",
      false: "!pl-4 !pc:pl-4"
    },
    size: {
      xlarge: "pl-8",
      large: "pl-6",
      medium: "pl-4"
    },
    pcSize: {
      xlarge: "pc:pl-8",
      large: "pc:pl-6",
      medium: "pc:pl-4"
    }
  }
}), w = p("shrink-0", {
  variants: {
    type: {
      filled_basic: "hover-never:[&>div]:bg-fill-neutral-weak1 focus:[&>div]:bg-fill-neutral-weak1",
      filled_blackop: "hover-never:[&>div]:bg-opacity-black-60 focus:[&>div]:bg-opacity-black-60"
    }
  }
}), N = ({
  currentPage: e,
  totalPages: c,
  type: r = "filled_basic",
  size: n,
  onClickAll: l
}) => {
  const m = `${e}`.padStart(2, "0"), u = `${c}`.padStart(2, "0"), i = typeof l == "function", t = f({
    property: n,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "medium", pc: "large" }
  }), d = x({ type: r, hasIcon: i, ...t }), g = I({ ...t }), b = v({ hasIcon: i, ...t });
  return /* @__PURE__ */ a(S, { onClick: l, type: r, children: /* @__PURE__ */ s("div", { className: d, children: [
    /* @__PURE__ */ a("span", { className: b, children: m }),
    /* @__PURE__ */ s("span", { children: [
      /* @__PURE__ */ a("span", { className: "mx-2", children: "/" }),
      /* @__PURE__ */ a("span", { children: u })
    ] }),
    i ? /* @__PURE__ */ a("div", { className: g, children: /* @__PURE__ */ a(y, { className: "size-full" }) }) : null
  ] }) });
}, S = ({
  children: e,
  type: c,
  onClick: r
}) => {
  const n = typeof r == "function", l = w({ type: c });
  return n ? /* @__PURE__ */ a("button", { "aria-label": "전체보기", className: o(l), onClick: r, type: "button", children: e }) : /* @__PURE__ */ a("div", { className: o(["inline-flex", "shrink-0"]), children: e });
};
N.displayName = "NDS.NumberIndicator";
export {
  N
};
